import { useQuery } from "@tanstack/react-query";
import type { POIs } from "@local-logic/client";
import { useLocalLogic } from "~/context/LocalLogicProvider";
import { poisKeys, poisResponse } from "~/features/pois";

type Options = {
  lat?: number;
  lng?: number;
  include?: (keyof POIs)[];
  limit?: number;
  radius?: number;
  attemptMinimum?: number;
};

export function usePois({
  lat,
  lng,
  include,
  // 30 is the default limit for POIs when getting combined POI categories
  limit = 30,
  radius = 2000,
  attemptMinimum,
}: Options) {
  const { client } = useLocalLogic();

  const options = {
    lat,
    lng,
    limit,
    radius,
    include,
    attemptMinimum,
  };

  return useQuery({
    queryKey: poisKeys.list(options),
    queryFn: async () => client.getPois(options as unknown as poisResponse),
    staleTime: Infinity,
    enabled:
      !!options && !!options.include?.length && !!options.lat && !!options.lng,
  });
}
